import { Modal } from "~/components";
import styles from "./UpdateAvailableModal.module.scss";
import { Button } from "~/new-ui-customer-questionnaire/components/Button/Button";

interface Props {
  isShow: boolean;
  onReload: () => void;
}

export const UpdateAvailableModal = ({ isShow, onReload }: Props) => {
  return (
    <Modal isShow={isShow} toggle={() => {}} isOutsideClick={false} isShowCloseButton={false}>
      <div className={styles.content}>
        <p className={styles.text}>Доступна новая версия приложения. Обновите страницу.</p>
        <Button
          type="button"
          aria-label="Вернуться"
          variant="secondary-alt"
          id="version-check-reload-button"
          name="Обновить"
          onClick={onReload}
          className={styles.button}
        >
          Обновить
        </Button>
      </div>
    </Modal>
  );
};
